import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Chip,
} from "@mui/material";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import DeckIcon from "@mui/icons-material/Deck";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import {
  resetTrackingData,
  Attendance,
  AttendanceProcess,
  Movements,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import { useDispatch } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendancePDF from "../../reports/AttendancePdf";
import { toast } from "react-hot-toast";
import { Employeeautocomplete } from "../../../ui-components/global/Autocomplete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { BikeScooterTwoTone } from "@mui/icons-material";
import MovementsPDF from "../../reports/MovementsPDF";
import { getConfig } from "../../../config";
import MovementsExcel from "../../reports/MovementsExcel";
import { FaFileExcel } from "react-icons/fa";

const Editmovements = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  var recID = params.id;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const EmpName = sessionStorage.getItem("EmpName");
  const CompanyID = sessionStorage.getItem("companyId");

  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);


 const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");
  

  const MovementsData = useSelector((state) => state.formApi.MovementsData);
  console.log("MovementsData", MovementsData);

  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const EMPID = sessionStorage.getItem("EmpId");
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const colors = tokens(theme.palette.mode);
  const [errorMsgData, setErrorMsgData] = useState(null);

  // useEffect(() => {
  //   fetch(process.env.PUBLIC_URL + "/validationcms.json")
  //     .then((res) => {
  //       if (!res.ok) throw new Error("Failed to fetch validationcms.json");
  //       return res.json();
  //     })
  //     .then((data) => {
  //       setErrorMsgData(data);
  //     })
  //     .catch((err) => console.error("Error loading validationcms.json:", err));
  // }, []);
  // useEffect(() => {
  //   dispatch(resetTrackingData());
  // }, []);
  useEffect(() => {
    // Get session values
    const savedEmpData = sessionStorage.getItem("movempData");
    const savedSelf = sessionStorage.getItem("movuseCurrentEmp") || "true";
    const savedMonth = sessionStorage.getItem("monthoftheyear");
    const savedYear = Number(sessionStorage.getItem("movyear"));

    // Default to current month/year if session is empty
    const emp = savedEmpData ? JSON.parse(savedEmpData) : null;
    const self = savedSelf === "true";

    const month = savedMonth || currentMonthNumber;
    const year = savedYear || currentYear;

    // Update states
    setmovempData(self ? null : emp);
    setmovUseCurrentEmp(emp ? false : self);

    const data = {
      Month: month,
      Year: year,
      EmployeeID: self ? EMPID : emp?.RecordID || 0,
      CompanyID,
    };

    dispatch(Movements({ data }));
  }, []);
  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>Attendance</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const AttColumn = [
    // {
    //   field: "SLNO",
    //   headerName: "SL#",
    //   width: 30,
    //   headerAlign: "center",
    //   align: "right"
    // },
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    // },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   width: 60,
    //   headerAlign: "center",
    //   renderCell: (params) => {
    //     if (params.row.Status === "WeekOff") {
    //       return <AlarmOffIcon color="primary" titleAccess="WeekOff" />;

    //     }
    //     if (params.row.Status === "HoliDay") {
    //       return <DeckIcon color="primary" titleAccess="Holiday" />;

    //     }
    //     return null;
    //   }
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerAlign: "center",
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      field: "Date",
      headerName: "Date",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Type",
      headerName: "Type",
      width: 200,
      headerAlign: "center",
    },
    {
      field: "Source",
      headerName: "Source",
      width: 150,
      headerAlign: "center",
    },
    {
      field: "TranDateTime",
      headerName: "Date & Time",
      width: 170,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Comments",
      headerName: "Comments",
      width: 420,
      headerAlign: "center",
    },
  ];

  /***********Attendance ************/

  const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const AttInitialvalues = {
    // code: data.Code,
    // description: data.Name,
    // Sal: data.Sal,
    monthoftheyear:
      sessionStorage.getItem("monthoftheyear") || currentMonthNumber,
    movyear: Number(sessionStorage.getItem("movyear")) || currentYear,
  };
  const attendaceFnSave = async (values) => {
    const data = {
      Month: values.monthoftheyear.toString(),
      Year: values.movyear,
      EmployeeID: movuseCurrentEmp ? EMPID : movempData.RecordID,
      //Project: proData.RecordID
      CompanyID,
    };
    console.log(data, "=====DATA");
    dispatch(Movements({ data }));

    // setButtonVisible(true)
  };

  const movloading = useSelector((state) => state.formApi.loading);

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const [movempData, setmovempData] = useState(null);
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      setmovempData(newValue);
      console.log(newValue.RecordID, "--selectedproductid");
    } else {
      setmovempData(null);
    }
    setmovUseCurrentEmp(false);
  };
  const [movuseCurrentEmp, setmovUseCurrentEmp] = useState(true);
  // const [proData, setproData] = useState(null);

  // const handleSelectionProjectChange = (newValue) => {
  //   if (newValue) {
  //     setproData(newValue);
  //   } else {
  //     setproData(null);
  //   }

  // };
  return (
    <React.Fragment>
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography
              variant="h3"
              sx={{ fontSize: "19px", marginLeft: "10px", color:"#0000D1"}}
            >
              {is003Subscription ? "Student Movement" : "Movements"}
            </Typography>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                setmovempData(null);
                dispatch(resetTrackingData());
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Stack direction="row" spacing={2}>
                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="monthoftheyear"
                    name="monthoftheyear"
                    label="Month"
                    value={values.monthoftheyear}
                    focused
                    // onChange={handleChange}
                    onChange={(e) => {
                      handleChange(e);
                      sessionStorage.setItem("monthoftheyear", e.target.value);
                    }}
                    onBlur={handleBlur}
                    select
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent", // optional: adjust if needed
                      },
                      width: 200,
                    }}
                  >
                    <MenuItem value={"1"}>January</MenuItem>
                    <MenuItem value={"2"}>February</MenuItem>
                    <MenuItem value={"3"}>March</MenuItem>
                    <MenuItem value={"4"}>April</MenuItem>
                    <MenuItem value={"5"}>May</MenuItem>
                    <MenuItem value={"6"}>June</MenuItem>
                    <MenuItem value={"7"}>July</MenuItem>
                    <MenuItem value={"8"}>August</MenuItem>
                    <MenuItem value={"9"}>September</MenuItem>
                    <MenuItem value={"10"}>October</MenuItem>
                    <MenuItem value={"11"}>November</MenuItem>
                    <MenuItem value={"12"}>December</MenuItem>
                  </TextField>

                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="movyear"
                    name="movyear"
                    label="Year"
                    value={values.movyear}
                    inputProps={{ min: "1900", max: "2100", step: "1" }}
                    focused
                    // onChange={handleChange}
                    onChange={(e) => {
                      handleChange(e);
                      sessionStorage.setItem("movyear", e.target.value);
                    }}
                    onBlur={handleBlur}
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent", // optional
                      },
                      width: 200,
                    }}
                  />
                  {/* {isManager === "1" ? (
                    <>
                      <Employeeautocomplete
                        sx={{ width: 400 }}
                        name="Employee"
                        label="Employee"
                        id="Employee"
                        value={empData}
                        onChange={handleSelectionEmployeeChange}
                        url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                      />
                    </>
                  ) : (
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="emp"
                      name="year"
                      label="Employee Name"
                      value={EmpName}
                      inputProps={{ min: "1900", max: "2100", step: "1" }}
                      focused
                      onChange={handleChange}
                      onBlur={handleBlur}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "transparent",
                        },
                        width: 400,
                      }}
                    />
                  )}
                    <FormControlLabel
          control={
            <Checkbox
              checked={useCurrentEmp}
              onChange={(e) => { setUseCurrentEmp(e.target.checked);
                setempData(null)}}
              color="primary"
            />
          }
          label="Self"
        /> */}
                  {/* <Employeeautocomplete

                    name="ProName"
                    label="Project"
                    id="ProName"
                    value={proData}
                    onChange={handleSelectionProjectChange}
                    error={!!touched.ProName && !!errors.ProName}
                    helperText={touched.ProName && errors.ProName}
                    url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${companyID}","Any":""}}`}
                  /> */}
                  {isManager == "1" && (
                    <Employeeautocomplete
                      sx={{ width: 400 }}
                      name="Employee"
                      label="Personnel"
                      id="Employee"
                      value={movempData}
                      // onChange={handleSelectionEmployeeChange}
                      onChange={(newValue) => {
                        setmovempData(newValue);
                        setmovUseCurrentEmp(false);
                        if (newValue)
                          sessionStorage.setItem(
                            "movempData",
                            JSON.stringify(newValue),
                          );
                        else sessionStorage.removeItem("movempData");
                      }}
                      url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${CompanyID}}}`}
                    />
                  )}

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={movuseCurrentEmp}
                        // onChange={(e) => {
                        //   setUseCurrentEmp(e.target.checked);
                        //   setempData(null);
                        // }}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setmovUseCurrentEmp(checked);
                          setmovempData(null);
                          sessionStorage.setItem("movuseCurrentEmp", checked);
                        }}
                        color="primary"
                      />
                    }
                    label="Self"
                  />
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  display="flex"
                  padding={1}
                  justifyContent="end"
                >
                  <Button type="submit" variant="contained" color="secondary">
                    APPLY
                  </Button>
                  <Button type="reset" variant="contained" color="error">
                    RESET
                  </Button>
                  {isManager === "1" && MovementsData?.length > 0 && (
                    <PDFDownloadLink
                      document={
                        <MovementsPDF
                          data={MovementsData}
                          filters={{
                            Month: values.monthoftheyear,
                            Year: values.movyear,
                            EmployeeID: movempData?.Name || EmpName,
                            Imageurl: baseurl1,
                            HeaderImg: HeaderImg,
                            FooterImg: FooterImg,
                          }}
                        />
                      }
                      fileName={`Movements_Report_${
                        movempData?.Name || "Personnel"
                      }.pdf`}
                      style={{ color: "#d32f2f", cursor: "pointer" }}
                    >
                      {({ loading }) =>
                        loading ? (
                          <PictureAsPdfIcon
                            sx={{ fontSize: 24, opacity: 0.5 }}
                          />
                        ) : (
                          <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                        )
                      }
                    </PDFDownloadLink>
                  )}

                  {isManager === "1" && MovementsData?.length > 0 && (
                    <FaFileExcel
                      size={20}
                      color="#1D6F42"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        MovementsExcel(
                          MovementsData,
                          {
                             Month: values.monthoftheyear,
                             Year: values.movyear,
                             EmployeeID: movempData?.Name || EmpName,
                          
                          },
                          // { month: values.month, year: values.year },
                          // empData
                        )
                      }
                    />
                  )}
                </Stack>
              </Box>
              <Box sx={{ gridColumn: "span 4" }}>
                <Box
                  height="500px"
                  // height={dataGridHeight}
                  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },

                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                    "& .weekoff-row": {
                      backgroundColor: "#f2acb7", // light red
                      color: "#b71c1c", // dark red text
                    },
                    "& .holiday-row": {
                      backgroundColor: "#c9f5cc", // light green
                      color: "#1b5e20", // dark green text
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={MovementsData}
                    columns={AttColumn}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    onCellClick={(params) => {}}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    loading={movloading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    // getRowClassName={(params) =>
                    //   params.indexRelativeToCurrentPage % 2 === 0
                    //     ? "odd-row"
                    //     : "even-row"
                    // }

                    // getRowClassName={(params) => {
                    //   const status = params.row.Status;
                    //   if (status === "WeekOff") return "weekoff-row";
                    //   if (status === "HoliDay") return "holiday-row";
                    //   return params.indexRelativeToCurrentPage % 2 === 0 ? "odd-row" : "even-row";
                    // }}
                  />
                </Box>
              </Box>
            </form>
          )}
        </Formik>
        {/* <Box display="flex" flexDirection="row" padding="15px" gap={formGap}>
          <Chip
            icon={<AlarmOffIcon color="primary" />}
            label="WeekOff"
            variant="outlined"
          />
          <Chip
            icon={<DeckIcon color="primary" />}
            label="Holiday"
            variant="outlined"
          />
        </Box> */}

        {/* <Box display="flex" flexDirection="row" padding="15px" gap={formGap}>
          <Chip
            icon={<AlarmOffIcon color="primary" />}
            label="WeekOff"
            variant="outlined"
            sx={{
              backgroundColor: "#f2acb7",
              borderColor: "#ef5350",
            }}
          />
          <Chip
            icon={<DeckIcon color="primary" />}
            label="Holiday"
            variant="outlined"
            sx={{
              backgroundColor: "#c9f5cc",
              borderColor: "#66bb6a",
            }}
          />
        </Box> */}
      </Paper>
    </React.Fragment>
  );
};

export default Editmovements;
